<template>
  <WrapperFormElements
    :label
    :required
    :hint
    :alertLabel
    :alertType
    :help
  >
    <BasicInputTelephone
      v-model="modelValue"
      :default-value
      :disabled
      :size
      :validation-state
      :placeholder
      :icon-state
      :icon-name
      :deletable
      :readonly
      :maxlength="14"
      :read-only-reason="props.readOnlyReason"
    />
  </WrapperFormElements>
</template>

<script setup lang="ts">
  import type { WrapperInputTelephoneProps, InputTelephoneModel } from '@designSystem/components'

  const props = defineProps<WrapperInputTelephoneProps>()

  const modelValue = defineModel<InputTelephoneModel>()
</script>
